import Vue from 'vue'
import Router from 'vue-router'

// components
import Auth from '@/components/Auth'
import Home from '@/components/Home'
import Dashboard from '@/components/Dashboard/index'
import Forbidden from '@/components/Forbidden'
import ControlPanel from '@/components/ControlPanel'

// navigation guards
import navGuards from './nav-guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/goaway',
      name: 'Away',
      component: { template: '<div>Redirecting...</div>' }
    },
    {
      path: '/',
      name: 'Root',
      redirect: '/home'
    },
    {
      path: '/auth',
      name: 'Authentication/Authorizaton',
      component: Auth,
      children: [
        {
          path: 'sso',
          meta: {
            authByToken: true
          }
        },
        {
          path: 'anonymous',
          meta: {
            signUpAnonymous: true
          }
        }
      ]
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/dashboard/:id',
      name: 'Dashboard',
      component: Dashboard,
      props: true,
      meta: {
        authRequired: true,
        dashboardAccessCheck: true
      }
    },
    // {
    //   path: '/control-panel',
    //   name: 'Control Panel',
    //   component: ControlPanel,
    //   meta: {
    //     authRequired: true
    //   }
    // },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden
    }
  ]
})

navGuards(router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js